import { Typography, Box, Card, CardContent } from '@mui/material';

interface Props {
  children?: JSX.Element;
  title: string;
  sx?: Record<string, unknown>;
}

function FormCard({ children, title, sx }: Props) {
  return (
    <Box
      maxWidth='421px'
      width='100%'
      sx={{
        margin: 0,
        ...sx,
      }}
    >
      <Box mb='25px'>
        <Typography variant='numberText' mb='20px' color='primary' fontWeight='600'>
          {title}
        </Typography>
      </Box>
      <Card
        elevation={3}
        sx={{
          overflow: 'visible',
        }}
      >
        <CardContent
          sx={{
            padding: '16px 24px 6px',
          }}
        >
          {children}
        </CardContent>
      </Card>
    </Box>
  );
}

export default FormCard;
